import React from 'react';
import ReactDOM from 'react-dom/client';
import App2 from './App2';
import Contacts from './Contacts';

document.addEventListener('DOMContentLoaded', () => {
  window.config = JSON.parse(document.getElementById('config').textContent);

  const mainEl = document.getElementById('main');
  const contactsEl = document.getElementById('contacts');

  if (mainEl) {
    const rootMain = ReactDOM.createRoot(mainEl);
    rootMain.render(
      <React.StrictMode>
        <App2
          trads={window.config.trads}
          products={window.config.products}
          user={window.config.user}
          lang={window.config.lang}
          langUrl={window.config.langUrl}
          activeEvents={window.config.activeEvents}
        />
      </React.StrictMode>
    );
  }

  if (contactsEl) {
    const rootContacts = ReactDOM.createRoot(contactsEl);
    rootContacts.render(
      <React.StrictMode>
        <Contacts
          trads={window.config.trads}
          products={window.config.products}
          user={window.config.user}
          lang={window.config.lang}
          langUrl={window.config.langUrl}
          authorizedCountries={window.config.authorizedCountries}
          activeEvents={window.config.activeEvents}
        />
      </React.StrictMode>
    );
  }
});
